var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{attrs:{"align-h":"start"}},[_c('b-col',{attrs:{"sm":"4"}},[(_vm.chart)?_c('AnalyticsLegend',{attrs:{"chart":_vm.chart}}):_vm._e()],1),_c('b-col',{attrs:{"sm":"4"}},[_c('canvas',{ref:"canvas",attrs:{"height":"250"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }